import clsx from 'clsx';
import { useMemo, cloneElement } from 'react';
import { DndContext } from '@dnd-kit/core';
import { restrictToVerticalAxis } from '@dnd-kit/modifiers';
import { SortableContext } from '@dnd-kit/sortable';
import useSorting from './useSorting';
import styles from '../styles.module.scss'; // const PREFIX = 'common: components: Accordion: variants: Sortable:';

import { jsx as _jsx } from "react/jsx-runtime";

const SortableAccordion = _ref => {
  let {
    className = '',
    onSortChange = () => undefined,
    onSortStart = () => undefined,
    onSortEnd = () => undefined,
    children
  } = _ref;
  const {
    isSorting,
    sortableContextId,
    handleDragStart,
    handleDragEnd
  } = useSorting({
    onSortChange,
    onSortStart,
    onSortEnd
  }); // Collect `sortId` values from immediate children

  const sortIdentifiers = useMemo(() => children.map(_ref2 => {
    let {
      props
    } = _ref2;
    return props.sortId;
  }).filter(id => typeof id !== 'undefined'), [children]);
  return /*#__PURE__*/_jsx(DndContext, {
    modifiers: [restrictToVerticalAxis],
    onDragStart: handleDragStart,
    onDragEnd: handleDragEnd,
    children: /*#__PURE__*/_jsx(SortableContext, {
      id: sortableContextId,
      items: sortIdentifiers,
      children: /*#__PURE__*/_jsx("div", {
        className: clsx(styles.container, className),
        children: children.map(child => /*#__PURE__*/cloneElement(child, {
          isSorting
        }))
      })
    })
  });
};

export default SortableAccordion;